import React, { Component } from 'react';
import styled from 'styled-components';
import FindCEForm from './components/FindCEForm';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchProfile } from '../../shared/redux/actions';

import Helmet from 'react-helmet';

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
`;

class FindCE extends Component {
  state = {
    loaded: false,
  };
  componentDidMount() {
    let type =
      (this.props.location.state && this.props.location.state.type) || null;
    if (this.isAuthenticated()) {
      this.props
        .fetchProfile()
        .then(action => {
          // let profession = action.data.program.trim() || '';
          // let state = action.data.state.trim() || '';

          let state = action.data.state
            .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
            .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);

          let profession = action.data.program
            .replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
            .replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);

          this.setState({ loaded: true });
          if (type !== 'change') {
            if (profession && state) {
              this.props.history.push(
                `${this.formatText(profession)}/${state}`
              );
            }
          }
        })
        .catch(error => {
          console.log(error);
          this.setState({ loaded: true });
        });
    } else {
      this.setState({ loaded: true });
    }
  }

  isAuthenticated = () => {
    return localStorage.getItem('authorization');
  };

  formatText = str => {
    let result = str.replace(/([A-Z])/g, '-$1');
    return result.charAt(0).toUpperCase() + result.slice(1);
  };

  render() {
    const { loaded } = this.state;
    if (loaded) {
      return (
        <Wrapper>
          <Helmet
            title="AchieveCE | Approved Continuing Education"
            meta={[
              { name: 'description', content: 'FindCE Page for AchieveCE' },
              { property: 'og:type', content: 'website' },
              {
                property: 'og:title',
                content: 'Approved Continuing Education',
              },
              { property: 'og:url', content: 'http://achievece.com/findce' },
            ]}
          />

          <FindCEForm />
        </Wrapper>
      );
    } else {
      return null;
    }
  }
}

export default withRouter(
  connect(
    null,
    { fetchProfile }
  )(FindCE)
);



// WEBPACK FOOTER //
// ./src/components/screens/FindCE/FindCE.jsx